import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

const containerBg = '#F8F9FA';//#F7F7F8 
const mainColor = '#6769DF';
const secondaryColor = '#14c4b4';

let theme = createTheme({
    typography: {
        fontFamily: [
            'Inter', // Primary font
            'Roboto', // Fallback for Material UI components
            'sans-serif',
        ].join(','),
        button: {
            textTransform: 'none', // This disables the default uppercase
        },
    },
    palette: {
        primary: {
            main: mainColor,//#5E17EB
            dark: "#4b4fc1",
            dark2: "#5E17EB",
            light1: "#9394f0",
            lightBg: "#F4F4FD",
            contrastText: '#FFF',
            lightText: '#212121b3',
            disabledInput: "rgba(0,0,0,0.04)",
            containerBg: containerBg
        },
        secondary: {
            main: secondaryColor,
            dark: "#0e8e84",
            lightBg: "#E7FAF8",
            contrastText: '#fff'
        },
        tertiary: {
            main: "#800080",
            light: "#993299",
            contrastText: '#fff'
        },
    },
    components: {
        //  Targets MUI Outlined variant (variant="outlined")
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: "#9394f0"
                    },
                },
            },
        },
        //  Targets MUI Standard variant (variant="standard")
        MuiInput: {
            styleOverrides: {
                root: {
                    '&:hover:not(.Mui-disabled, .Mui-error):before': {
                        borderBottom: "1px solid #9394f0"
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(9, 11, 26, 0.4)', // Deeper, cinematic overlay
                        backdropFilter: 'blur(12px)', // Enhanced premium glass effect
                    },
                },
                paper: {
                    borderRadius: 28, // Uber-modern, smooth pill-corners
                    padding: 0, // CRITICAL: Reset total padding to let sections blend seamlessly
                    overflow: 'hidden',
                    boxShadow: '0px 24px 60px rgba(103, 105, 223, 0.08), 0px 16px 32px rgba(0, 0, 0, 0.04)', // Tailored soft glow
                    border: '1px solid rgba(255, 255, 255, 0.7)', // Subtle inner stroke
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '32px 32px 16px 32px', // Deeper, intentional breathing room
                    fontSize: '1.4rem',
                    fontWeight: 800,
                    color: '#0f172a',
                    letterSpacing: '-0.03em',
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '0 32px 24px 32px', // Lines up perfectly with the title grid
                    color: '#475569',
                    fontSize: '0.975rem',
                    lineHeight: 1.6,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '20px 32px 32px 32px', // Balanced bottom anchor
                    borderTop: '1px solid #f1f5f9', // Clean, crisp separation instead of empty space
                    background: '#fafafa', // Subtle background shift to anchoring actions beautifully
                    gap: 12,
                    '& .MuiButton-root': {
                        borderRadius: 14,
                        textTransform: 'none',
                        fontWeight: 700,
                        padding: '12px 24px', // Taller, more clickable modern tap-targets
                        fontSize: '0.925rem',
                        transition: 'all 0.2s ease-in-out',
                    },
                    '& .MuiButton-text': {
                        color: '#64748b',
                        '&:hover': { background: '#f1f5f9', color: '#334155' },
                    },
                    '& .MuiButton-containedPrimary': {
                        boxShadow: '0 10px 20px -6px rgba(103, 105, 223, 0.4)',
                        '&:hover': {
                            boxShadow: '0 12px 24px -4px rgba(103, 105, 223, 0.6)',
                            transform: 'translateY(-1px)', // Subtle reactive lift
                        },
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: mainColor,
                    color: 'white',
                    borderRadius: '4px',
                },
                arrow: {
                    color: mainColor,
                },
            },
        },
        MuiRating: {
            styleOverrides: {
                // Target the active/filled star icons
                iconFilled: {
                    color: mainColor, // Replace with your desired filled color
                },
                // Target the hover state icon color
                iconHover: {
                    color: mainColor, // Replace with your desired hover color
                },
                // Optional: Target the empty/unfilled star icons
                iconEmpty: {
                    color: mainColor, // Replace with your desired empty outline color
                },
            },
        },
    }
})
theme = responsiveFontSizes(theme);

export default theme;